import { factoryService, getJsonRequest, postFormRequest } from '@chilecompra/react-kit/requests'

import { REACT_APP_API_BASE_URL } from '../config/settings/environment.config'

const CFMP_API_URL = `${REACT_APP_API_BASE_URL}/v1/api/cfmp`

/**
 * Creates a new CFMP (Compra Fuera de Mercado Público) along with its attached files
 */
export const createCfmp = factoryService(({ attachedFiles, cfmp }) =>
  postFormRequest(`${CFMP_API_URL}/create`, {
    body: {
      cfmp: JSON.stringify(cfmp),
      files: attachedFiles.map(({ file }) => file)
    }
  })
)

/**
 * Fetches administrative act types
 */
export const fetchAdministrativeActTypes = factoryService(() =>
  getJsonRequest(`${CFMP_API_URL}/administrative-act-types`)
)

/**
 * Fetches currencies
 */
export const fetchCurrencies = factoryService(() => getJsonRequest(`${CFMP_API_URL}/currencies`))

/**
 * Fetches procedure types
 */
export const fetchProcedureTypes = factoryService(() =>
  getJsonRequest(`${CFMP_API_URL}/procedure-types`)
)

/**
 * Fetches reason types
 */
export const fetchReasonTypes = factoryService(() => getJsonRequest(`${CFMP_API_URL}/reason-types`))
